<template>
  <div>
    <b-card title="Last Paid Order">
      <!-- search input -->

      <!-- <b-row class="mb-1">
        <b-col>
          <section>
            <b-button
              v-b-modal.modal-filter-refunds
              variant="outline-primary"
              class="d-flex text-primary"
            >
              <feather-icon icon="FilterIcon" />Filter
            </b-button>
          </section>
        </b-col>
        <b-col>
          <b-form-group
            v-if="dataFiltered === true"
            class=" d-flex justify-content-center"
          >
            <b-form-input
              v-model="searchTerm"
              placeholder="Search"
              type="search"
            />
          </b-form-group>
        </b-col>

        <b-col v-if="dataFiltered === true" class="d-flex justify-content-end">
          <xlsx-workbook>
            <xlsx-sheet
              v-for="sheet in sheets"
              :key="sheet.name"
              :collection="sheet.data"
              :sheet-name="sheet.name"
            />
            <xlsx-download>
              <b-button variant="primary" class="d-flex">
                <feather-icon icon="DownloadCloudIcon" /> Export
              </b-button>
            </xlsx-download>
          </xlsx-workbook>
        </b-col>
      </b-row> -->

      <!-- table -->
      <vue-good-table
        :columns="columns"
        :rows="rows"
        :search-options="{
          enabled: true,
          externalQuery: searchTerm,
        }"
        :pagination-options="{
          enabled: true,
          perPage: pageLength,
        }"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field === 'paymentOptionEnum'">
            <span>
              {{
                paidPaymentOptions.filter(
                  (f) => props.row.paymentOptionEnum == f.value
                )[0].text
              }}
            </span>
          </span>
        </template>

        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap"> Showing 1 to </span>
              <b-form-select
                v-model="pageLength"
                :options="['5', '10', '15', '30', '50']"
                class="mx-1"
                @input="
                  (value) => props.perPageChanged({ currentPerPage: value })
                "
              />
              <span class="text-nowrap"> of {{ props.total }} entries </span>
            </div>
            <div>
              <b-pagination
                :value="1"
                :total-rows="props.total"
                :per-page="pageLength"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @input="(value) => props.pageChanged({ currentPage: value })"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>

      <!-- loadings -->
      <b-overlay :show="isLoading" no-wrap rounded="sm" />
    </b-card>

    <b-card title="Payment Options with No Transactions">
      <!-- search input -->
      <b-row>
        <div v-for="item in noTransaction" :key="item">
          <b-col>
            <b-badge pill variant="primary">{{ item }}</b-badge>
          </b-col>
        </div>
      </b-row>

      <!-- loadings -->
      <b-overlay :show="isLoading" no-wrap rounded="sm" />
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BAvatar,
  BBadge,
  BPagination,
  BOverlay,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BRow,
  BCol,
  BButton,
  BForm,
  BModal,
  BSpinner,
  BCardBody,
  BTable,
  BFormTextarea,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import flatPickr from "vue-flatpickr-component";
import axios from "@axios";
import store from "@/store";
import XlsxSheet from "vue-xlsx/dist/components/XlsxSheet";
import XlsxDownload from "vue-xlsx/dist/components/XlsxDownload";
import XlsxWorkbook from "vue-xlsx/dist/components/XlsxWorkbook";

export default {
  name: "Users",
  components: {
    BRow,
    BCard,
    VueGoodTable,
    BAvatar,
    BBadge,
    BOverlay,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BCol,
    BButton,
    BForm,
    BModal,
    BCardBody,
    BTable,
    BFormTextarea,
    BSpinner,
    flatPickr,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
  },
  props: {
    proprefundHistory: {
      type: Object,
    },
  },
  data() {
    const nowDate = new Date();
    return {
      isLoading: false,
      dataFiltered: false,
      rows: [],
      pageLength: 5,
      isDeleteModel: false,
      dir: false,
      rangeDate: null,
      activeRow: null,
      extendedDate: `${nowDate.getUTCFullYear()}-${
        nowDate.getUTCMonth() + 1
      }-${nowDate.getUTCDate()}`,
      trxnDateRangeQueue: "",
      trxnStartDate: "",
      trxnEndDate: "",
      selectedOrder: "",
      filterflyGateOrderId: "",
      filterCurrency: "",
      filtervendorTxnRefNumber: "",
      filtercustomOrderCode: "",
      filterStatus: 0,
      filterTicketNumber: "",
      trxnDateRangePaidDate: "",
      trxnStartDatePaidDate: "",
      selectedPaidPaymentOptions: 0,
      fromAmount: 0,
      toAmount: 0,
      trxnEndDatePaidDate: "",
      columns: [
        {
          label: "Paid Payment Option",
          field: "paymentOptionEnum",
        },
        {
          label: "Custom Order Code",
          field: "customOrderCode",
        },
        {
          label: "OrderId",
          field: "orderId",
        },
        {
          label: "Amount",
          field: "amount",
        },
        {
          label: "Currency",
          field: "currency",
        },
        {
          label: "order Date",
          field: "orderDate",
        },
        {
          label: "Vendor TxnRef No",
          field: "vendorTxnRefNumber",
        },
        {
          label: "Paid Date",
          field: "paidDate",
        },
      ],
      noTransaction: [],
      paidPaymentOptions: [],
      selectedCurrency: "ETB",
      searchTerm: "",
      refundworkflowHistory: [],
      refundhistories: [],
      cancelOrderExceptionfield: {
        Id: 0,
        Remark: "",
      },
      approveOrderExceptionfield: {
        Id: 0,
        Remark: "",
      },
      sheets: [{ name: "Detail Refund Requests", data: [] }],
    };
  },

  created() {
    this.fetchallPaymentOptions();
    this.GetCurrentTransaction();
  },
  methods: {
    fetchallPaymentOptions() {
      this.isLoading = true;
      this.$store.dispatch("config/getActionPrivilege", "Order-View");
      axios
        .get(
          "/PaymentOptions/api/V1.0/PaymentOptions/ViewMerchantPaymentOptions"
        )
        .then((res) => {
          res.paymentOptions.forEach((item) => {
            this.paidPaymentOptions.push({
              value: item.paymentOption,
              text: item.name,
            });
          });
          console.log(this.paidPaymentOptions);
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    GetCurrentTransaction() {
      this.isLoading = true;
      this.$store.dispatch(
        "config/getActionPrivilege",
        "Report-ManualTransaction"
      );
      axios
        .get("/Order/api/V1.0/Report/GetLastTransactionForEachPaymentOption")
        .then((res) => {
          console.log(res);
          this.rows = [];
          this.sheets[0].data = [];
          this.dataFiltered = true;
          this.rows = res.orders;
          this.noTransaction = res.paymentOptionsHasNoTransactions;

          //   res.orders.map((m) => {
          //     this.sheets[0].data.push({
          //       "Transaction Queue Date": m.transactionQueueDate,
          //       "Custom Order Code": m.customOrderCode,
          //       "Order Id": m.flyGateOrderId,
          //       Amount: m.amount,
          //       Currency: m.currency,
          //       "Paid Payment Option": this.paidPaymentOptions.filter(
          //         (f) => m.paymentOptionId === f.value
          //       )[0].text,
          //       "Paid Date": m.paidDate,
          //       "Vendor TxnRef. Number": m.vendorTxnRefNumber,
          //       "Ticket Number": m.ticketNumber,
          //       Agent: m.agent,
          //       Status: this.statusOptions.filter(
          //         (f) => m.paymentStatus == f.value
          //       )[0].text,
          //       "Action Taken By": m.actionTakenBy,
          //       "Action Taken Date": m.actionTakenDate,
          //       Remark: m.remark,
          //     });
          //   });
          this.isLoading = false;
        })
        .catch((err) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: `${err.data.message}`,
            },
          });
          this.isLoading = false;
        });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
